import { Organisation } from '~organisations/domain';

import logo from './images/logo.png';

const telstraBusinessConfig: Organisation = {
  logo: logo,
  additionalOutcomeCaptureFields: {},
  asyncAdditionalOutcomeCaptureFields: {},
  contactAssessmentForms: {},
};

export default telstraBusinessConfig;
